import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Utils } from './utils';

@Injectable({
    providedIn: 'root'
})
export class StatsService {
    
    constructor(private _http: HttpClient, private _utils: Utils) { }

    getPendingReviewStats() {
        return this._http.get(
            `${this._utils.backURL}/api/stats/rw-pending`,
            this._utils.jwt()
        ).toPromise();
    }

    getAccountRegisters() {
        return this._http.get(
            `${this._utils.backURL}/api/stats/account-registers`,
            this._utils.jwt()
        ).toPromise();
    }

    getCompletedReviewStats() {
        return this._http.get(
            `${this._utils.backURL}/api/stats/rw-completed`,
            this._utils.jwt()
        ).toPromise();
    }

}
